import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDeliveryReceipts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('purchase/delivery-receipts', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteDeliveryReceipt(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`purchase/delivery-receipts/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
